import { useEffect, useRef, useState } from "react";
import Carousel, { CarouselProps } from "react-multi-carousel";

export const AutoStoppingCarousel: React.FC<CarouselProps> = (props) => {
    const divRef = useRef<HTMLDivElement>(null);
    const [autoPlay, setAutoPlay] = useState(false);

    useEffect(() => {
        const callback = () => {
            var rect = divRef.current!.getBoundingClientRect();
            var elemTop = rect.top;
            var elemBottom = rect.bottom;

            // Only completely visible elements return true:
            var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
            // Partially visible elements return false (it would seem):
            //isVisible = elemTop < window.innerHeight && elemBottom >= 0;

            setAutoPlay(isVisible);
        }
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, []);
    return (
        <div ref={divRef}>
            <Carousel {...props} autoPlay={autoPlay} />
        </div>
    );
}